import React from 'react';
import { MultiComboboxProps } from 'pounceV2';
import { FastField, FieldConfig, useFormikContext } from 'formik';
import FormikComboboxV3 from 'Components/fields/ComboBox/ComboBoxV3';
import { severityItemToString } from 'Pages/Build/Detections/utils';
import { SEVERITY_TYPES_IN_ORDER } from 'Source/constants';
import { SimpleRuleFormValues } from 'Pages/Build/Detections/Rules/SimpleRuleForm/SimpleRuleFormV3';
import { SimplePolicyFormValues } from 'Pages/Build/Detections/Policies/SimplePolicyForm/SimplePolicyFormV3';

type SeverityFieldProps = {
  canEdit?: boolean;
  label?: string;
  name?: string;
} & Omit<FieldConfig, 'name'> &
  Partial<MultiComboboxProps<any>>;

const severityOptions = SEVERITY_TYPES_IN_ORDER;

const SeverityFieldV3: React.FC<SeverityFieldProps> = ({
  canEdit,
  label = 'Severity',
  name = 'severity',
  ...rest
}) => {
  const { values, validateField } = useFormikContext<
    SimpleRuleFormValues | SimplePolicyFormValues
  >();

  return (
    <FastField
      as={FormikComboboxV3}
      id={name}
      label={label}
      name={name}
      items={severityOptions}
      itemToString={severityItemToString}
      showClearSelectionControl={false}
      disabled={!canEdit}
      onSelect={() => {
        if (values.severity != null) {
          // Clear error on selection
          validateField('severity');
        }
      }}
      {...rest}
    />
  );
};

export default SeverityFieldV3;
